export default __webpack_public_path__ + "static/media/ITRealCase2-moblie-en.03d23df5.jpg";